import { useCallback, useMemo } from 'react';

import { useScreenState } from '@gogame/screens';
import { CHART_COLORS } from '@gogame/components';

export const getColorByIndex = (index) => {
  return CHART_COLORS[index % CHART_COLORS.length];
};

export const useSeriesIdColorGetter = (series) => {
  const ids = useMemo(() => series.map(({ id }) => id), [series]);

  return useCallback(
    (id) => {
      if (ids.indexOf(id) === -1) {
        ids.push(id);
        //sum seria
        // return theme.palette.primary.main;
      }
      return getColorByIndex(ids.indexOf(id));
    },
    [ids]
  );
};

export const useSateSeries = () => {
  const state = useScreenState();
  return state?.temporary?.series || state?.series;
};
